module.exports = __webpack_public_path__ + "static/media/abs-hotline3.111e7881.png";